module.exports = __webpack_public_path__ + "img/Rookie-6.67b92f6c.gif";